<style scoped>
.submit-btn {
  padding: 2px 12px;
  height: 34px;
}

.total-container {
  margin-bottom: .25rem;
}

.total-container span {
  color: #444444;
  padding: 3px;
}

.explicit-text {
  top: 15px
}
</style>

<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
            <h5 class="text-center">Income  <span class="text-small align-middle">*Yearly</span>
            </h5>
          <hr/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vue-form-generator
          :schema="schema"
          :options="formOptions"
          :model="model"
          ref="incomeForm"
          ></vue-form-generator>
          <b-row>
            <b-col>
              <div class="text-right col-md-12">
                <div class="total-container">
                  <span>Total Income: {{ totalIncome }}</span>
                </div>
                <div>
                  <b-button
                    class="btn-anchor submit-btn raised"
                    @click="submitIncome"
                    id="btn-update-income"
                  >
                    Update Income
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center explicit-text">
          <explicit-hint text="We accept your Personal, Entity Assets and Liabilities"/>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>


<script>
import VueFormGenerator from 'vue-form-generator';
import incomeSchema from '@/components/profile/sections/tabs/financial/income/schema';
import ExplicitHint from '@/components/utils/hints/ExplicitHint';

import helper from '@/libs/helper';
import { UPDATE_INCOME } from '@/vuex/modules/profile/types/actions';


export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    ExplicitHint,
  },
  data() {
    return {
      model: {},
      schema: incomeSchema.schema,
      formOptions: incomeSchema.formOptions,
    };
  },
  watch: {
    finances() {
      this.setModel();
    },
  },
  computed: {
    income() {
      const profile = this.$store.getters.profile;
      return profile && profile.finances.income ? profile.finances.income : null;
    },
    totalIncome() {
      const model = this.model;
      const values = [
        model.salary,
        model.netInvestmentIncome,
        model.realEstateIncome,
        model.otherIncome,
      ];
      return helper.currencySum(values);
    },
  },
  methods: {
    setModel() {
      this.model = helper.copy(this.income) || {};
    },
    submitIncome() {
      if (this.$refs.incomeForm.validate()) {
        this.$reqs.post(`/users/${this.$store.getters.user.id}/profile/finance`, this.model)
          .then((response) => {
            this.$store.dispatch(UPDATE_INCOME, response.data.finances);
            this.$emit('income-updated');
          })
          .catch(() => {});
      }
    },
  },
  created() {
    this.setModel();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/financial/income/IncomeContainer.vue